export default "__VITE_ASSET__TI8Ij0aC__"